import { SERPCardResult, SERPSellerResult } from "shared/types/serpResult";
import { getEnvironment } from "../getEnvironment";
import { converterData } from "./converterData";
import { getDataParam } from "./getDataParam";

const getRedirectBaseURL = () => {
  const environment = getEnvironment();

  if (environment === "development") {
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    return `${origin}/redirect`;
  }

  if (environment === "staging") {
    return "https://staging.voopter.com.br/redirect";
  }

  return "https://voopter.com.br/redirect";
};

export const getDeeplink = (
  cardResult: SERPCardResult,
  seller: SERPSellerResult,
) => {
  const redirectBaseURL = getRedirectBaseURL();
  let outboundDepartureDate: string;
  let returnDepartureDate: string | null = null;

  const price = ((seller.price * 10) / 100).toFixed(2);
  const webservice = getDataParam(seller.integrationName || seller.sellerId);

  outboundDepartureDate = converterData(cardResult.sectors[0].departureDate);

  if (cardResult.sectors[1]) {
    returnDepartureDate = converterData(cardResult.sectors[1].departureDate);
  }

  const deepLinkURL = `${redirectBaseURL}?url=${encodeURIComponent(
    seller.deepLink,
  )}&domain=${seller.sellerId}&sale[totalCost]=BRL${price}&sale[origin]=${
    cardResult.sectors[0].departureAirportIata
  }&sale[destination]=${
    cardResult.sectors[0].arrivalAirportIata
  }&sale[leaveDate]=${outboundDepartureDate}&sale[data2]=${webservice}&sale[data3]=${
    cardResult.sectors[0].airline
  }&sale[data4]=${seller.sellerName}&sale[partnerLogo]=${encodeURIComponent(
    seller.sellerImg,
  )}&sale[nAdults]=1&sale[nChildren]=0&sale[nBabies]=0${
    returnDepartureDate ? `&sale[returnDate]=${returnDepartureDate}` : ""
  }`;

  console.log("Deep Link:", deepLinkURL);

  return deepLinkURL;
};
